import  { useEffect, useState } from 'react'
import { RhyBusButton } from '@rhybus/button'
import { RhyBusCustomSelect } from '@rhybus/form-controls'
import { ConfigurationFormat } from './formatcontent'
import { rhybusRListsHttp } from '../../../api/rhybus-list-http'
import { ListNames, SelectOption } from '../../../config/configuration'

interface EditableTextParameters {
  id: number;
  text?: string;
  text1?: string;
  useState?: any;
  DataObj?: any;
  Enable?: any
  mainId?: any
  ParamMode?: any
}
const EditableText = (props: any) => {
  const SELECT_VALUE: SelectOption[] = [
    { label: 'Low', value: 'Low' },
    { label: 'Medium', value: 'Medium' },
    { label: 'High', value: 'High' },
  ]

  const [clicked, setClicked] = useState<any>('')
  const [editCategoryName, setEditCategoryName] = useState<any>('')
  const [editCategorySeverity, setEditCategorySeverity] = useState<SelectOption | null>(null)
  const [, setCatError] = useState(false)
  const toggle = (index: any,) => {
    setClicked((prev: any) => (prev === index ? null : index))
  }
  const [texts, setTexts] = useState<EditableTextParameters[]>([])

  useEffect(() => {
    const objectPreparation: any = []
    if (props?.Items) {
      props?.Items.forEach((element: any, _index: any) => {
        objectPreparation.push({
          id: element?.CID, text: element?.CategoryParamName, text1: element?.Severity, Enable: element?.IsEnable, mainId: element?.ID, ParamMode: element?.ParamMode
        })
      })
    }
    setTexts(objectPreparation)
  }, [props?.Items])
  const [editingId, setEditingId] = useState<number | null>(null)
  const handleEdit = (id: number) => {
    setEditingId(id)

  }
  const handleSave = (value: any, _eKey: any, IsEnableUpdate: any, mainId: any) => {
    const ObjectArray: any = {}
    if (IsEnableUpdate) {
      ObjectArray.ID = mainId
      ObjectArray.IsEnable = String(value)
      ObjectArray.ItemModifiedById = (window as any)._spPageContextInfo?.userId ?? 0
      ObjectArray.ItemModified = new Date()
      rhybusRListsHttp().getList(ListNames?.PIICATEGORY).then(async (list) => {
        await list.addOrUpdateItem({eKey: String(mainId), ...ObjectArray} as any)
        props?.getCategories()
        props?.getData()
        setEditingId(null)
      })
    } else if (editCategoryName?.trim() !== '') {
      ObjectArray.ID = mainId
      ObjectArray.CategoryParamName = editCategoryName
      ObjectArray.Severity = editCategorySeverity?.value
      ObjectArray.ItemModified = new Date()
      ObjectArray.ItemModifiedById = (window as any)._spPageContextInfo?.userId ?? 0
      rhybusRListsHttp().getList(ListNames?.PIICATEGORY).then(async (list) => {
        await list.addOrUpdateItem({eKey: String(mainId), ...ObjectArray} as any)
        props?.getCategories()
        props?.getData()
        setEditingId(null)
      })
    } else {
      setCatError(true)
    }
  }
  const handleCancel = () => {
    setEditingId(null)
  }

  return (
    <>
      {texts.map((text, index) => (
        <div className='piiaccordionlist  border-1' key={text.id}>
          {editingId === text.id
            ? (
              <div className='d-flex align-items-center px-2  py-1 piiaccordionlistheader'>
                <div className={clicked === text.id ? 'icon-rb-arrow-down-thick rotate-180 font-13 color-primary' : 'icon-rb-arrow-down-thick font-13 color-primary'} aria-expanded={clicked === text.id ? 'true' : 'false'} title={clicked === text.id ? 'Expanded' : 'Collapsed'} tabIndex={0} onKeyDown={(event) => { event.key === 'Enter' && toggle(text.id) }}></div>
                <div className='d-flex form-xs ps-2'>
                  <input
                    type="text"
                    value={editCategoryName}
                    className='form-sm w-100 customselect'
                    onChange={(e) => setEditCategoryName(e.target.value)}
                  />
                  <div className='dividerdashed vertical mx-2'></div>
                  {/* <input
                                        type="text1"
                                        value={editCategorySeverity}
                                        onChange={(e) => setEditCategorySeverity(e.target.value)}
                                    /> */}

                  <RhyBusCustomSelect
                    id='Severity'
                    label="Severity"
                    options={SELECT_VALUE}
                    value={editCategorySeverity}
                    onChange={setEditCategorySeverity}
                    isMandatory
                  />
                  {/* <CustomSelect
                    id='Severity'
                    value={[editCategorySeverity]}
                    formClassName="form-vertical text-nowrap poppins-medium"
                    className='form-xs w-100 customselect'
                    isMandatory
                    defaultSelect={true}
                    infoClassName="tool-tip tooltip-top font-12 sourcesanspro"
                    info="Severity"
                    infoIcon="icon-rb-info"
                    isInfo
                    defaultValue={true}
                    options={SELECT_VALUE}
                    onChange=
                    menuPosition="fixed"
                  /> */}
                </div>
                <div className='ms-auto d-flex gap-1'>
                  <RhyBusButton
                    onClick={() => {
                      handleSave('', text.id, false, text.mainId)
                    }}
                    label="Save"
                    aria-label="Save"
                    leftIcon="icon-rb-checked font-11"
                  />

                  <RhyBusButton onClick={handleCancel}
                    label="Cancel"
                    aria-label="Cancel"
                    leftIcon="icon-rb-close font-11  "
                  />
                </div>
              </div>
            )
            : (
              <>
                <div className={clicked === text.id ? 'd-flex px-2 py-1 piiaccordionlistheader active' : 'd-flex piiaccordionlistheader px-2 py-1'} aria-expanded={clicked === text.id ? 'true' : 'false'} aria-controls={`piiaccordionlist-${index}`}>
                  <div tabIndex={0} className='d-flex w-100 align-items-center' onClick={() => toggle(text.id)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        toggle(text.id)
                      }
                    }}
                  >
                    <div
                      className={
                        clicked === text.id
                          ? 'icon-rb-arrow-down-thick font-13 me-2 rotate-180 color-primary'
                          : 'icon-rb-arrow-right-thick font-13 me-2 color-primary'
                      }
                      title={clicked === text.id ? 'Expanded' : 'Collapsed'}
                      tabIndex={0}
                      onKeyDown={(event) => {
                        if (event.key === 'Enter') {
                          toggle(text.id)
                        }
                      }}
                    ></div>

                    <div tabIndex={0} aria-label={text.text} className='text-uppercase text-color-12'>{text.text}</div>
                    <div className='dividerdashed vertical mx-2'></div>
                    <div tabIndex={0} aria-label={text.text1} className={`severity  ${text?.text1}`}>Severity: {text.text1}</div>
                  </div>
                  {!props?.isPredefinedCategories &&
                    <RhyBusButton onClick={() => {
                      handleEdit(text.id)
                      setCatError(false)
                      setEditCategoryName(text.text)
                      setEditCategorySeverity(SELECT_VALUE.find((item) => item.label === text.text1) || null)
                    }}
                      label="Edit"
                      aria-label="Edit"
                      leftIcon="icon-rb-pencil font-11"
                    />
                  }
                  <input tabIndex={0} type='checkbox' key={text.id} className="react-switch-checkbox" id={props.id} name={props.id} />

                  {/* <RhyBusSwitch
            id={text.id}
            checked={text.Enable}
            getCategories={props}
            onChange={handleSave}
          /> */}
                  {/* <Switch key={text.id} id={text.id} Enable={text.Enable} getCategories={props} onChange={handleSave} mainId={text.mainId} /> */}
                </div>
                {clicked === text.id
                  ? <div className={clicked === text.id ? 'configurationlists border-top-2 border-bottom-2  active' : 'configurationlists pb-2'} id={`piiaccordionlist-${index}`}>
                    <ConfigurationFormat Item={clicked} ParamMode={text.ParamMode} formats={props?.formats} getData={props} />
                  </div>
                  : ''}
              </>
            )}
        </div>
      ))}

    </>
  )
}

export default EditableText
